import $ from "jquery";
import {LazyImages} from "./modules/lazyImages";
import Colcade from "colcade/colcade";
import {FormFilterClass} from "./modules/FormFilterClass";
import Menu from "./modules/menu";

const $window = $(window);
const $body = $('body');

/** ----------------------------------------
 Calculate Negative margin for button
 ---------------------------------------- */

// require('./modules/text_with_image_playful_button_calculator');


/** ----------------------------------------
 Calculate aside height in gap block
 ---------------------------------------- */

require('./modules/block_with_gap');


/** ----------------------------------------
 Calculate magin for outlet header
 ---------------------------------------- */

require('./modules/outlet_header');


/** ----------------------------------------
 Calculate aside height in gap block
 ---------------------------------------- */

$(function () {
    new Menu();
    new LazyImages($body);
});

let popupTrigger = document.getElementsByClassName('js-popup-trigger');

if (popupTrigger.length) {
    let popup = document.getElementById('popup-callback');
    let popupClose = popup.querySelector('.popup__content__close');
    let popupBtn = document.querySelector('.popup-btn');

    popupBtn.addEventListener('click', function () {
        togglePopUp();
    });

    popupClose.addEventListener('click', function () {
        togglePopUp();
    });

    function togglePopUp() {
        if (!popup.classList.contains('active')) {
            popup.classList.add('active');
        } else {
            popup.classList.remove('active');
        }
    }
}


/****************************
 *
 * Colcade
 *
 ***************************/

let grid = null;
let gridClone = document.querySelector('.grid-clone');
let gridContainer = document.querySelector('.grid');

if (gridContainer) {
    grid = new Colcade(gridContainer, {
        columns: '.grid-col',
        items: '.grid-item'
    });
}
/****************************
 *
 * News overview LazyLoad
 *
 ***************************/

let ajaxContainer = document.getElementById('ajax-results');

new FormFilterClass({
    form: document.getElementById('form-training'),
    container: ajaxContainer,
    lazyload: 400,
    loader: document.getElementById('append_loader'),
    processResponse: ($container, $dom, $append, result) => {
        let node = document.createRange().createContextualFragment($dom);
        let total = result.total;
        let totalField = document.getElementById('training-total');
        let totalPlaceholder;

        if ($append) {
            grid.append(node);
        } else {
            if (total === 1) {
                totalPlaceholder = ' training gevonden';
            } else {
                totalPlaceholder = ' trainingen gevonden';
            }
            totalField.innerHTML = total + totalPlaceholder;

            gridContainer.innerHTML = gridClone.innerHTML;
            if ($dom) {
                gridContainer.append(node);
                grid = new Colcade(gridContainer, {
                    columns: '.grid-col',
                    items: '.grid-item'
                });
                grid.reload();
            }
        }
    }
});

let leesvoerContainer = document.getElementById('ajax-results-leesvoer');

new FormFilterClass({
    form: document.getElementById('form-reading-material'),
    container: leesvoerContainer,
    lazyload: 400,
    loader: document.getElementById('append_loader'),
    processResponse: ($container, $dom, $append, result) => {
        let node = document.createRange().createContextualFragment($dom);

        if ($append) {
            grid.append(node);
        } else {
            gridContainer.innerHTML = gridClone.innerHTML;
            if ($dom) {
                gridContainer.append(node);
                grid = new Colcade(gridContainer, {
                    columns: '.grid-col',
                    items: '.grid-item'
                });
                grid.reload();
            }
        }
    }
});


let maps = document.getElementsByClassName('map');

if (maps.length) {
    for (let i = 0; i < maps.length; i++) {
        let gmap = maps[i];
        google.maps.event.addDomListener(window, 'load', function () {
            let map, position;
            let gps = JSON.parse(gmap.dataset.map);

            map = new google.maps.Map(gmap, {
                center: position,
                zoom: 14,
                disableDefaultUI: true,
                draggable: false,
                scrollwheel: false,
            });
            position = new google.maps.LatLng(gps[0], gps[1]);

            var bounds = new google.maps.LatLngBounds();
            bounds.extend(position);
            var marker = new google.maps.Marker({
                position: position,
                map: map,
            });
            map.setCenter(position);
        });
    }
}
